import type { ClusterListItem } from '@b4b/shared';
import GridCard from '../GridCard.js';
import FeedFooter, { type Pager } from './FeedFooter.js';
import FilterChips from './FilterChips.js';
import { useCardKeyboard } from '../../lib/useCardKeyboard.js';
import type { FeedParams } from '../../lib/feedUrl.js';

// Feedly "cards" style: equal-height cards, 2 columns on phones, 3 from `sm`, 4 from `lg`
// (the page container widens to max-w-6xl for this layout, see Layout.tsx).
export default function GridFeed({
  items,
  params,
  pager,
  fetchingFirstArticles,
}: {
  items: ClusterListItem[];
  params: FeedParams;
  pager: Pager;
  fetchingFirstArticles: boolean;
}) {
  const focusIndex = useCardKeyboard(items);
  return (
    <div data-layout="grid" className="px-3 pb-4 pt-20">
      <FilterChips params={params} />
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
        {items.map((item, index) => (
          <GridCard key={item.id} item={item} focused={index === focusIndex} />
        ))}
      </div>
      <FeedFooter itemCount={items.length} params={params} pager={pager} fetchingFirstArticles={fetchingFirstArticles} />
    </div>
  );
}
